'use client';

import React from 'react';
import { Layout } from 'antd';
import styled from '@emotion/styled';
import { WithThemes } from '@/components/ThemesProvider';
import DashboardSidebar from './Sidebar';
import DashboardNavbar from './Navbar';
import DashboardContent from './Content';
import PageLoader from './PageLoader'; // Movemos el loader a su propio archivo

const { Sider, Content } = Layout;

const StyledLayout = styled(Layout)`
  height: 100vh;
  display: flex;
`;

const MainContent = styled(Layout)`
  flex: 1;
  overflow: hidden;
`;

const LayoutDashboard = ({ children }: { children: React.ReactNode }) => (
  <WithThemes>
    <PageLoader />
    <StyledLayout hasSider>
      <DashboardSidebar />
      <MainContent>
        <DashboardNavbar />
        <DashboardContent>{children}</DashboardContent>
      </MainContent>
    </StyledLayout>
  </WithThemes>
);

export default LayoutDashboard;